import React from 'react';

import ImagePickerField from 'components/Form/ImagePickerField';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LogoPickerField = ({
  altText,
  centerButton,
  confirmModal,
  description,
  extraAnalyticsData,
  label,
  message,
  name,
  noMargin,
  onChange,
  overlayButton,
  previewHeight,
  previewWidth,
  recommendedDimensions,
  size,
  ...props
}: {
  altText?: string;
  buttonOnly?: boolean;
  centerButton?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmModal?: Record<string, any>;
  'data-qa-id'?: string;
  description?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraAnalyticsData?: Record<string, any>;
  hideRemove?: boolean;
  inlineLabel?: boolean;
  label?: string;
  message?: string;
  name: string;
  noMargin?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  overlayButton?: boolean;
  previewCropToCircle?: boolean;
  previewHeight?: number | Array<number | null | undefined>;
  previewWidth?: number | Array<number | null | undefined>;
  recommendedDimensions?: {
    height: number;
    width: number;
  };
  size?: number;
}) => (
  <ImagePickerField
    altText={altText}
    previewWidth={size || 128}
    previewHeight={size || 128}
    format="logo"
    message={message || getText('Drag a logo here')}
    name={name}
    label={label}
    description={description}
    centerButton={centerButton}
    overlayButton={overlayButton}
    confirmModal={confirmModal}
    onChange={onChange}
    noMargin={noMargin}
    extraAnalyticsData={extraAnalyticsData}
    recommendedDimensions={recommendedDimensions}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

export default LogoPickerField;
